var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4.99984C11.7157 4.99984 5.00002 11.7156 5.00002 19.9998C5.00002 28.2841 11.7157 34.9998 20 34.9998C28.2843 34.9998 35 28.2841 35 19.9998C35 11.7156 28.2843 4.99984 20 4.99984ZM1.66669 19.9998C1.66669 9.87462 9.8748 1.6665 20 1.6665C30.1252 1.6665 38.3334 9.87462 38.3334 19.9998C38.3334 30.1251 30.1252 38.3332 20 38.3332C9.8748 38.3332 1.66669 30.1251 1.66669 19.9998Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18.3335C20.9205 18.3335 21.6666 19.0797 21.6666 20.0002V26.6668C21.6666 27.5873 20.9205 28.3335 20 28.3335C19.0795 28.3335 18.3333 27.5873 18.3333 26.6668V20.0002C18.3333 19.0797 19.0795 18.3335 20 18.3335Z",
    fill: "#60666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 13.3332C18.3333 12.4127 19.0795 11.6665 20 11.6665H20.0166C20.9371 11.6665 21.6833 12.4127 21.6833 13.3332C21.6833 14.2536 20.9371 14.9998 20.0166 14.9998H20C19.0795 14.9998 18.3333 14.2536 18.3333 13.3332Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.e370ee13c524f64565ac539b2c22027a.svg";